export default __webpack_public_path__ + "static/media/accesories.f8032b24.jpeg";